module.exports = __webpack_public_path__ + "img/large5.c88d4177.jpg";